<script setup lang="ts">
  import { useImage } from '@/composables/useImage'
  import  { IbexaImageVariations } from '@/enums/IbexaImageVariations'
  import type { Author } from '@/types/Author'

  import RichTextRenderer from '@/components/common/RichTextRenderer.vue'
  import Typography from '@/components/common/Typography.vue'

  defineProps<{
    author: Author
  }>()

  const { getImageByField } = useImage()
</script>

<template>
  <div>
    <img
      v-if="author.image?.destinationContentId"
      class="resource-image"
      aria-hidden="true"
      :src="getImageByField(author.image?.destinationContentId, 'image', IbexaImageVariations.Article780)"
      :alt="author.image?.alternativeText"
      data-testid="author-image"
    >
    <Typography
      variant="body"
      component="h4"
      :font-weight="700"
      data-testid="author-name"
    >
      {{ author.firstname }} {{ author.lastname }}
    </Typography>
    <div v-if="author?.description" data-testid="author-description">
      <RichTextRenderer :rich-text="author.description" />
    </div>
  </div>
</template>


<style lang="scss" scoped>
  img {
    width: 153px;
    padding-bottom: 16px;
  }

  :deep(.cms-p) {
    margin: 0;
  }
</style>
